module.exports = __webpack_public_path__ + "static/img/A146.2ef94637.jpg";